<template>
  <yes-no-label :value="params.value"></yes-no-label>
</template>

<script>
export default {
  name: "AgGridYesNoLabel",
};
</script>
